import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provide } from '@kros-sk/core/di';

import { APPLICATION_MODULES_API_URL, ApplicationModulesApiService } from './application-modules-api.service';
import { ApplicationModulesFacade } from './application-modules.facade';
import { ApplicationModulesStore } from './application-modules.store';

interface ApplicationModulesConfig {
  apiUrl: string;
}

export function provideApplicationModules(config: ApplicationModulesConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    provide(APPLICATION_MODULES_API_URL, { useValue: config.apiUrl }),
    ApplicationModulesApiService,
    ApplicationModulesStore,
    ApplicationModulesFacade,
  ]);
}
